<template>
	<v-container class="mt-4 ml-2" fluid>
	  <v-row>
	  	<v-col cols="12" md="8" lg="6">
	  		<v-card class="shadowCard">
		      
		      <v-card-title class="text-subtitle-1">
		      	Asistente de Soporte Técnico
		      	<v-spacer></v-spacer>
		      	<v-img src="@/assets/iconos/soporte.png" height="36" max-width="36" />
		      </v-card-title>

		      <!-- Iniciar el chat por primera vez -->
		      <v-card-text v-if="!estado">
		      	<div
		        	v-for="(problema, i) in problemas"
		        	:key="i"
		        	class="mb-2"
		      	>
			        <v-chip 
			        	color="blue"
	      				outlined
	      				label
	      				@click="iniciarChat( problema.id )"
			        >
			        	<v-icon left>
					        mdi-wrench
					      </v-icon>
			      		{{ problema.titulo }}
			      	</v-chip>
		      	</div>
		      </v-card-text>	

		      <!-- Cuando ya se seleccionó un problema -->
		      <v-card-text v-if="estado" class="mt-6 black--text">

		      	<!-- Está es la sección de pregunta -->
		        <div v-if="estado.tipo === 'pregunta'">
		          <p class="text-subtitle-1 font-weight-bold">{{ estado.pregunta }}</p>
		          <v-btn
		            v-for="respuesta in estado.respuestas"
		            :key="respuesta.id"
		            class="ma-2"
		            color="primary"
		            @click="iniciarChat(respuesta.id)"
		          >
		            {{ respuesta.texto }}
		          </v-btn>
		        </div>

		      	<!-- Está es la sección de la solución -->
		        <div v-else-if="estado.tipo === 'solucion'">
		          <p class="text-subtitle-1 font-weight-bold">
		          	<v-img src="@/assets/iconos/idea.png" height="24" max-width="24" />
	        	 	  Solución sugerida:
	        	 	  <br/>
	        	 	  <br/>
	        		</p>

		          <p>{{ estado.solucion }}</p>
		          <v-chip 
		          	color="success" 
		          	class="mt-4"
		          	outlined
	      				label 
		          	@click="reiniciar"
		          >
		          	<v-icon left>
					        mdi-refresh
					      </v-icon>
		        		Iniciar de nuevo
		        	</v-chip>
		        </div>

		      </v-card-text>
		    </v-card>
		  </v-col>
		</v-row>
  </v-container>
</template>

<script>

	import axios from 'axios'

	// Componentes
  import Alerta              from '@/components/alertas/Alerta.vue'
  import carga               from '@/components/alertas/carga.vue';

  import validarErrores      from '@/mixins/validarErrores'

	export default {

		components:{
      Alerta,
      carga,
    },

    mixins: [ validarErrores ],

	  name: 'ChatSoporte',

	  data: () => ({
	    
	    // Alertas
    	parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

      ruta: [],
      estado: null,
      problemas: []

	  }),

	  created () {

	    this.initialize()

	  },

	  methods: {

	    async initialize () {

	    	this.cargar = true

	      this.$http.get('soporte.problemas').then(response=>{

		    	this.cargar = false

	      	this.problemas = response.data

	      	console.log( this.problemas )

	      }).catch( error =>{
	        this.validarError( error.response.data.message )
	      }).finally( () => { this.cargar = false })

	    },

	    seleccionarRespuesta (id) {
	      this.ruta.push(id)
	      this.initialize()
	    },

	    reiniciar () {
	      this.ruta = []
	      this.estado = null
	    },

	    iniciarChat( id ){
	    	this.cargar = true

	    	this.ruta.push( id )

	      this.$http.post('soporte.chat', this.ruta ).then(response=>{

		    	this.cargar = false

	      	this.estado = response.data

	      	console.log( this.estado )

	      }).catch( error =>{
	        this.validarError( error.response.data.message )
	      }).finally( () => { this.cargar = false })
	    }

	  }
	}
</script>
